import { Patient } from "../../../api/patient.types";
import { MedcardViewAction } from "./medcard.view.types";

export const medcardViewPatientSetAction = (patient: Patient): MedcardViewAction => ({ type: 'MEDCARD_VIEW_PATIENT_SET', params: patient })
export const medcardViewPatientClearAction = (): MedcardViewAction => ({ type: 'MEDCARD_VIEW_PATIENT_CLEAR' })